import { render, staticRenderFns } from "./FabricComposition.vue?vue&type=template&id=507428dc&scoped=true"
import script from "./FabricComposition.vue?vue&type=script&lang=js"
export * from "./FabricComposition.vue?vue&type=script&lang=js"
import style0 from "./FabricComposition.vue?vue&type=style&index=0&id=507428dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507428dc",
  null
  
)

export default component.exports